import { render, staticRenderFns } from "./OutrightsMenuResults.vue?vue&type=template&id=4076cd14"
import script from "./OutrightsMenuResults.vue?vue&type=script&lang=js"
export * from "./OutrightsMenuResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports